import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class LandingBannerButton extends BaseModel {
  static override constructorName = 'LandingBannerButton'

  title: string = ''
  align: string = ''
  link: string = ''
  'is_show': boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['is_show'])

      this.is_show = Boolean(Number(data.is_show))
    }
  }
}
